import { ProductPage } from './product.component';
import { connect } from 'react-redux';
import { fetchProduct, addToWishlist, removeToWishlist } from "./../../api/product/productAction";
import { addToCart, updateCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    fetchProduct,
    addToCart,
    updateCart,
    addToWishlist,
    removeToWishlist
};

const mapStateToProps = state => ({
    isLoading: state.productPage.isLoading,
    isAdded: state.productPage.isAdded,
    product: state.productPage.product,
    cart: state.cartPage.cart,
    isLoggedIn: state.userPage.isLoggedIn
});

export const ProductContainer = connect(mapStateToProps, mapDispatchToProps)(ProductPage);